import React from "react";
import styles from "./portfolioRischioRendimentoTableCompare.module.scss";
import { useTranslation } from "react-i18next";

const PortfolioRischioRendimentoTableCompare = ({
  dataItem,
  dataItem2,
  subSection = false,
}) => {
  const { t } = useTranslation();

  // Validate that both datasets exist
  if (!dataItem || !dataItem.data || !dataItem2 || !dataItem2.data) {
    return null;
  }

  // Use the configuration from dataItem (they should be identical as per your example)
  const configData = dataItem.configData;

  return (
    <div
      className={`${styles.tableContainer} ${
        subSection ? styles.subSection : ""
      }`}
    >
      <table className={styles.compareTable}>
        <thead>
          <tr className={styles.subHeaderRow}>
            <th className={styles.assetClassHeader}>
              {configData.label_table_left}
            </th>
            <th className={styles.portfolioHeader}>
              {t("portafoglioCompare.portafoglio1")}
            </th>
            <th className={styles.portfolioHeader}>
              {t("portafoglioCompare.portafoglio2")}
            </th>
          </tr>
        </thead>
        <tbody>
          {dataItem.data.map((row, index) => {
            // Find matching row in dataItem2 by label
            const matchingRow = dataItem2.data.find(
              (item) => item.label === row.label,
            ) || { weight: 0 };

            // Get display label from config if available
            const displayLabel =
              configData && configData.rows
                ? configData.rows[row.label] || row.label
                : row.label;

            return (
              <tr key={index}>
                <td className={styles.assetClassCell}>{displayLabel}</td>
                <td
                  className={`${styles.valueCell} ${styles.firstPortfolioValue}`}
                >
                  {row.weight.toFixed(2)}
                </td>
                <td className={styles.valueCell}>
                  {matchingRow.weight.toFixed(2)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PortfolioRischioRendimentoTableCompare;
